import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

// Колокольчик уведомлений: индикатор непрочитанных + список по клику.
// endpoint — базовый путь (GET список+unread_count, POST endpoint/read-all).
// viewAllPath — маршрут страницы "Все уведомления" (N-062), без пункта в сайдбаре.
export default function NotificationBell({ endpoint, tokenKey, viewAllPath }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const ref = useRef(null);

  const headers = useCallback(() => ({ Authorization: 'Bearer ' + localStorage.getItem(tokenKey) }), [tokenKey]);

  const fetchCount = useCallback(() => {
    axios.get(`${API}${endpoint}`, { headers: headers() }).then(r => setUnread(r.data.unread_count)).catch(() => {});
  }, [endpoint, headers]);

  useEffect(() => {
    fetchCount();
    const t = setInterval(fetchCount, 60000);
    return () => clearInterval(t);
  }, [fetchCount]);

  useEffect(() => {
    const onClickOutside = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (!next) return;
    try {
      const r = await axios.get(`${API}${endpoint}`, { headers: headers() });
      setItems(r.data.items);
      setUnread(r.data.unread_count);
      setLoaded(true);
      if (r.data.unread_count > 0) {
        axios.post(`${API}${endpoint}/read-all`, {}, { headers: headers() })
          .then(() => setUnread(0))
          .catch(() => {});
      }
    } catch { /* тихо игнорируем — колокольчик не критичен */ }
  };

  return (
    <div ref={ref} style={s.wrap}>
      <div style={s.bell} onClick={toggle} title="Уведомления">
        🔔
        {unread > 0 && <span style={s.badge}>{unread > 9 ? '9+' : unread}</span>}
      </div>
      {open && (
        <div style={s.dropdown}>
          <div style={s.dropdownHead}>
            <span style={s.dropdownTitle}>Уведомления</span>
            {viewAllPath && (
              <span style={s.viewAll} onClick={() => { setOpen(false); navigate(viewAllPath); }}>Посмотреть все</span>
            )}
          </div>
          <div style={s.list}>
            {!loaded ? (
              <div style={s.empty}>Загрузка…</div>
            ) : items.length === 0 ? (
              <div style={s.empty}>Уведомлений пока нет</div>
            ) : items.map(n => (
              <div key={n.id} style={{ ...s.item, ...(n.read_at ? {} : s.itemUnread) }}>
                <div style={s.itemTitle}>{n.title}</div>
                <div style={s.itemBody}>{n.body}</div>
                <div style={s.itemDate}>{new Date(n.created_at).toLocaleString('ru')}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  wrap: { position: 'relative' },
  bell: { cursor: 'pointer', fontSize: 20, position: 'relative', display: 'inline-flex', width: 40, height: 40, alignItems: 'center', justifyContent: 'center', borderRadius: 10, background: '#fff', border: '1px solid #eef2f7' },
  badge: { position: 'absolute', top: -4, right: -4, background: '#e5484d', color: '#fff', borderRadius: 10, fontSize: 11, fontWeight: 700, minWidth: 18, height: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 4px' },
  dropdown: { position: 'absolute', top: 48, right: 0, width: 340, background: '#fff', borderRadius: 14, boxShadow: '0 10px 30px rgba(27,43,75,0.15)', border: '1px solid #eef2f7', zIndex: 100, display: 'flex', flexDirection: 'column' },
  dropdownHead: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 18px', borderBottom: '1px solid #f4f7fb' },
  dropdownTitle: { fontWeight: 700, color: '#1B2B4B', fontSize: 15 },
  viewAll: { color: '#149e90', fontSize: 12, fontWeight: 600, cursor: 'pointer' },
  list: { display: 'flex', flexDirection: 'column', maxHeight: 380, overflowY: 'auto' },
  item: { padding: '12px 18px', borderBottom: '1px solid #f4f7fb' },
  itemUnread: { background: '#f0fffe' },
  itemTitle: { fontSize: 14, fontWeight: 700, color: '#1B2B4B', marginBottom: 4 },
  itemBody: { fontSize: 13, color: '#475569', lineHeight: 1.4, marginBottom: 6, whiteSpace: 'pre-wrap' },
  itemDate: { fontSize: 11, color: '#94a3b8' },
  empty: { padding: '24px 18px', textAlign: 'center', color: '#94a3b8', fontSize: 13 },
};
